import { createTheme as createDSTheme } from 'app/shopify';
import { ListingType } from 'app/types/listing';

const theme = createDSTheme();

export const PROMPT_BANNER_MAX_WIDTH = 450;
export const MINT_LISTING_PROMPT_BACKGROUND = '#B8ECE0';
export const POST_OFFER_CARD_ART_ASPECT_RATIO = 347 / 185;

export const listingPromptBannerSharedInnards = {
  contentGap: 'spacing.general.x2' as const,
  contentPaddingHorizontal: 'spacing.general.x4' as const,
  contentPaddingTop: 'spacing.general.x4' as const,
};

export const mintListingPromptBannerLayout = {
  backgroundColor: MINT_LISTING_PROMPT_BACKGROUND,
  ...listingPromptBannerSharedInnards,
};

export const mintListingPromptTitleTextProps = {
  fontSize: 22,
  fontWeight: '700' as const,
  textAlign: 'left' as const,
  variant: 'bodyBase' as const,
};

export const mintListingPromptBodyTextProps = {
  fontSize: 16,
  textAlign: 'left' as const,
  variant: 'bodyBase' as const,
};

export const promptBannerScreenHorizontalGutter = theme.spacing['spacing.general.x6'];

export const promptBannerPrimaryButtonStyle = {
  alignSelf: 'flex-start' as const,
  backgroundColor: theme.colors['surface.inverse.default'],
  borderRadius: theme.borderRadii['radius.lg'],
  paddingLeft: theme.spacing['spacing.general.x6'],
  paddingRight: theme.spacing['spacing.general.x4'],
  paddingVertical: theme.spacing['spacing.general.x2'],
};

export const promptBannerPillButtonStyle = {
  alignSelf: 'flex-start' as const,
  backgroundColor: theme.colors['surface.inverse.default'],
  borderRadius: 16,
  height: 32,
};

export function promptBannerV2NeedButtonStyle(width: number, type: ListingType) {
  return {
    alignSelf: 'flex-start' as const,
    backgroundColor:
      type === ListingType.request
        ? theme.colors['surface.tertiary']
        : theme.colors['surface.inverse.tertiary-neutral'],
    borderRadius: 38,
    height: 76,
    justifyContent: 'center' as const,
    paddingLeft: theme.spacing['spacing.general.x6'],
    paddingRight: theme.spacing['spacing.general.x4'],
    width,
  };
}
